import { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import type { WorkflowRule } from '../types';

const DEALERSHIP_MMDID_FIELD = 'dealership.mmdid';

export const missingDealershipRule: WorkflowRule = (state: any): WorkflowStatus | null => {
    const { missingFields = [] } = state?.salesCheckin?.dealValidation ?? {};
    return missingFields.includes(DEALERSHIP_MMDID_FIELD) ? WorkflowStatus.INVALID : null;
};
